<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="amzSkuCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="
        !multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              strict: false,
              reserve: reserve,
            }
          : {}
      "
      :checkbox-config="
        multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              reserve: reserve,
            }
          : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="
            row.amzPurchaseStatus === 'N'
              ? 'primary'
              : row.amzPurchaseStatus === 'Y'
              ? 'success'
              : row.amzPurchaseStatus === 'D'
              ? 'danger'
              : 'warning'
          "
        >
          {{ row.v_amzPurchaseStatus }}
        </el-tag>
      </template>
      <template v-slot:totalAmount="{row}">
        <span>{{ row.totalAmount + ' ' + (row.v_currencyUnit ? row.v_currencyUnit : '--') }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    tableHeight: { type: Number, default: 800 },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    radioChange({ row }) {
      this.$emit('choose-change', row)
    },
  },
}
</script>
